<template>
  <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 300 300" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    <path d="M171.5,40.9h41.7l81.7,54.9-173.6,100.6L5,135,171.5,40.9ZM213.3,40.9l-119.1,71,27.2,84.5M5,135l89.2-23M21,143.4v55l105.7,60.6,154.2-88.8v-66.3M126.3,193.6v65.4M166.8,187.4l21.8-12.4v27.3l-21.8,12.7v-27.6ZM229,153.5l21.8-12.4v27.3l-21.8,12.7v-27.6h0Z" />
  </svg>
</template>
